import { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'
import { PROVIDER_EVENT_NAMES, tracking } from 'lib/segment/tracking'
import { useSelector } from 'react-redux'

export function useTrackViewPatientChart() {
  const [searchParams] = useSearchParams()
  const id = searchParams.get('id')
  const refSearchParam = searchParams.get('ref')
  const hasTrackedRef = useRef<boolean>(false)
  // @ts-expect-error TS2538 -- MIGRATION: not approved, fix when encountered
  const patientInfo = useSelector((state: any) => state.chartsReducer.patientInfo?.[id])

  useEffect(() => {
    if (hasTrackedRef.current || !patientInfo?.PatientId) {
      return
    }

    const { PatientId, VisitSummary } = patientInfo

    tracking.trackEvent(PROVIDER_EVENT_NAMES.VIEW_PATIENT_CHART, {
      // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
      Location: refSearchParam,
      PatientId,
      PatientPastVisitCount: VisitSummary?.CountPast,
      PatientUpcomingVisitCount: VisitSummary?.CountUpcoming,
    })

    hasTrackedRef.current = true
  }, [id, patientInfo, refSearchParam])
}
